import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { SelectedProduct } from '../App';
interface ProductsSectionProps {
  onRentProduct?: (product: SelectedProduct) => void;
}
export const products: SelectedProduct[] = [{
  name: '3 Wheel or 4 Wheel Heavy-Duty Scooter',
  price: 45.0,
  image: 'https://wheelaroundrentals.com/wp-content/uploads/2022/10/3-or-4-wheel-heavy-duty-scooter-280x280.png'
}, {
  name: '3 Wheel or 4 Wheel Scooter',
  price: 35.0,
  image: 'https://wheelaroundrentals.com/wp-content/uploads/2022/10/Image-3-280x242.png'
}, {
  name: 'Baby Stroller',
  price: 25.0,
  image: 'https://wheelaroundrentals.com/wp-content/uploads/2022/10/71WUfYZnwDL-280x280.jpg'
}, {
  name: 'Heavy Duty Manual Wheelchair',
  price: 25.0,
  image: 'https://wheelaroundrentals.com/wp-content/uploads/2022/10/Image-5-280x242.png'
}, {
  name: 'Knee Walker',
  price: 14.0,
  image: 'https://wheelaroundrentals.com/wp-content/uploads/2022/10/Image-1-280x242.png'
}, {
  name: 'Manual Wheelchair',
  price: 20.0,
  image: 'https://wheelaroundrentals.com/wp-content/uploads/2022/10/Image-2-280x242.png'
}, {
  name: 'Power Wheelchair',
  price: 50.0,
  image: 'https://wheelaroundrentals.com/wp-content/uploads/2022/10/Image-280x242.png'
}, {
  name: 'Rollator Walker',
  price: 18.0,
  image: 'https://wheelaroundrentals.com/wp-content/uploads/2022/10/5-280x242.png'
}];
export function ProductsSection({
  onRentProduct
}: ProductsSectionProps) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="products" className="py-24 bg-brand-gray" data-id="element-293">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-294">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-295">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex items-center justify-center gap-3 mb-4" data-id="element-296">
            <div className="h-[2px] w-8 bg-brand-red" data-id="element-297"></div>
            <span className="text-brand-red font-bold tracking-wider text-sm uppercase" data-id="element-298">
              Our Products
            </span>
            <div className="h-[2px] w-8 bg-brand-red" data-id="element-299"></div>
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-brand-navy mb-6" data-id="element-300">
            Mobility Products Available For Rent
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg text-brand-charcoal/70" data-id="element-301">
            3 days minimum for all rentals. You can call{' '}
            <a href="tel:+18003954459" className="text-brand-red font-bold hover:underline" data-id="element-302">
              1(800)-395-4459
            </a>{' '}
            for more information or details.
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-303">
          {products.map((product, index) => <motion.div key={index} variants={cardVariants} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100 hover:shadow-xl hover:-translate-y-2 transition-all duration-300 group flex flex-col h-full" data-id="element-304">
              <div className="bg-gray-50 p-6 flex items-center justify-center aspect-square relative overflow-hidden" data-id="element-305">
                <img src={product.image} alt={product.name} className="w-full h-full object-contain mix-blend-multiply group-hover:scale-110 transition-transform duration-500" data-id="element-306" />
              </div>

              <div className="p-6 flex flex-col flex-grow" data-id="element-307">
                <h3 className="text-lg font-bold text-brand-navy mb-4 flex-grow" data-id="element-308">
                  {product.name}
                </h3>

                <div className="flex items-baseline mb-6" data-id="element-309">
                  <span className="text-sm text-brand-charcoal/60 mr-1" data-id="element-310">
                    From
                  </span>
                  <span className="text-2xl font-extrabold text-brand-red" data-id="element-311">
                    ${product.price.toFixed(2)}
                  </span>
                  <span className="text-sm text-brand-charcoal/60 ml-1" data-id="element-312">
                    /day
                  </span>
                </div>

                <button onClick={() => onRentProduct?.(product)} className="w-full py-3 bg-brand-navy/5 text-brand-navy rounded-xl font-bold text-center hover:bg-brand-red hover:text-white transition-colors flex items-center justify-center gap-2 group/btn cursor-pointer" data-id="element-313">
                  Rent Now
                  <ArrowRightIcon className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" data-id="element-314" />
                </button>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}